export class Documents {
  static readonly NibTermsOfBusiness = '/terms-of-business-nib';
  static readonly PrivacyNotice = '/privacy';
  static readonly GroupPrivacyPolicy = '/privacy-group-policy';
  static readonly IDRFeedback = '/contact-us/feedback';
  static readonly FAQ = '/help';
  static readonly COVIDFAQ = '/travel-alerts/coronavirus';
  static readonly TravelAlerts = '/travel-alerts';
  static readonly Claims = '/contact-us/claims-form';
  static readonly TermsOfUse = '/terms-of-use';
}
